import Contract from "./Contract";
import Invoice from "./Invoice";
import Job from "./Job";
import Payroll from "./Payroll";
import Template from "./Template";

const Status = {
  Invoice,
  Job,
  Payroll,
  Contract,
  Template,
};

export default Status;
